import React, { useState, useEffect } from 'react';
import SearchTab from './SearchTab';
import AdminTab from './AdminTab';
import './Tabs.css'; // custom CSS
import banner from './assets/banner.png'; // Adjust path if needed

function App() {
  const [activeTab, setActiveTab] = useState('search');
  const [isAdmin] = useState(true); // toggle admin visibility
  const [visitors, setVisitors] = useState(null);


  useEffect(() => {
    fetch('/api/visit')
    //fetch('https://vedaai-xbbd.onrender.com/api/visit')
      .then(res => res.json())
      .then(data => setVisitors(data.visitors))
      .catch(err => console.error('Error fetching visitor count:', err));
  }, []);

  return (
    <div className="site-container">
      {/* Full-width banner image */}
      {/* Text-based header */}
      <header className="site-header">
        ॐ श्री परमात्मने नमः
      </header>

      {/* <img src={banner} alt="VedaAI Banner" className="site-banner" /> */}

      {/* Banner Tabs */}
      {/* <div className="top-tabs">
        <div
          className={`tab-blue ${activeTab === 'search' ? 'active' : ''}`}
          onClick={() => setActiveTab('search')}
        >
          Search
        </div>
        {isAdmin && (
          <div
            className={`tab-blue ${activeTab === 'admin' ? 'active' : ''}`}
            onClick={() => setActiveTab('admin')}
          >
            Admin
          </div>
        )}
      </div> */}
      {/* Visitor Counter */}
      <div className="visitor-counter">
        {visitors !== null ? `Visitor count: ${visitors}` : 'Loading visitor count...'}
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === 'search' && <SearchTab />}
        {activeTab === 'admin' && isAdmin && <AdminTab />}
      </div>

      {/* Sanskrit Footer */}
      <footer className="site-footer">
        श्रुतिस्मृतिपुराणानामालयं करुणालयम् । नमामि भगवत्पादं शङ्करं लोकशङ्करम् ॥
        © 2025 Krishna Yajur Vedam Search Tool
      </footer>
    </div>
  );
}

export default App;